// src/components/LandingPage.js
import React from 'react';
import './LandingPage.css';
import { Link } from 'react-router-dom';
 import Reso from './Reso';
 import RESO3 from './images/RESO3.svg';

const LandingPage = () => {
    return (
        <div className="landing-page">
            <div className="intro">
                <h1>Hey, we're <span className="highlight">Blogy</span>.<br></br>See our thoughts, stories and ideas.</h1>
                <div className="line"></div>
            </div>
            <div className="start-blogging">
                <h2><span className="highlights">Start Blogging.</span><br></br> Build Your Brand.
                <ul>
                    <li>Share your story & expertise.</li>
                    <li>Grow your audience.</li>
                    <li>Monetize your passion.</li>
                </ul>
                </h2>
            </div>
            <div className="imagecontainer">
                <img src={RESO3} alt="Blogging" />
            </div>
           
            <button className="cta-button">
          <Link to="/blog" className="t">Write Your Blog</Link>
          
        </button>
<Reso/>
        </div>
    );
};

export default LandingPage;
